export default __webpack_public_path__ + "static/media/FirstBurn.ee7f0ffc.svg";